import { List } from 'immutable';
import { fundConstants } from '../constants';

export function funds(state = {}, action) {
  switch (action.type) {
    case fundConstants.FUND_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case fundConstants.FUND_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case fundConstants.FUND_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: List([]),
        listError: action.error
      };
    case fundConstants.FUNDS_DATA_LOAD_SUCCESS: {
      if (!state.items) return state;

      const fundsWithData = state.items.map(fund => {
        const responseForFund = action.response.find(f => f.fundId === fund.id);
        if (responseForFund) {
          fund.fundData = responseForFund.fundData;
        }
        return fund;
      });

      return {
        ...state,
        items: fundsWithData
      };
    }
    case fundConstants.FUND_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case fundConstants.FUND_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case fundConstants.FUND_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case fundConstants.FUND_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case fundConstants.FUND_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const fundIndex = state.items.findIndex(val => val.id == action.response.id);

      if (fundIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(fundIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case fundConstants.FUND_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case fundConstants.FUND_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case fundConstants.FUND_DELETE_SUCCESS: {
      const { fundId } = action;

      if (!state.items) {
        return state;
      }

      const fundIndex = state.items.findIndex(val => val.id == fundId);

      if (fundIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(fundIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case fundConstants.FUND_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case fundConstants.FUND_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
